module.exports = __webpack_public_path__ + "img/productIcon.8a0dc4a6.png";